module.exports = __webpack_public_path__ + "static/logo-fec4f77e2c2c6664328c7788991caa59.png";